var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import ModalBanner from './ModalBanner';
import ModalHeader from './ModalHeader';
import { HorizontalBorder, ModalRewardsWrapper, ModalWrapper } from './subcomponents';
var ModalContentWrapper = function (_a) {
    var children = _a.children;
    return (_jsxs(ModalWrapper, __assign({ "data-testid": "modal-content-wrapper" }, { children: [_jsx(ModalHeader, {}), _jsx(Stack, { size: "medium", hideOnBreakpointDown: "small" }), _jsx(HorizontalBorder, {}), _jsxs(ModalRewardsWrapper, __assign({ all: "large", hideOnBreakpointDown: "medium" }, { children: [_jsx(ModalBanner, {}), children] }))] })));
};
export default ModalContentWrapper;
